import { Box, makeStyles, LinearProgress, Typography } from "@material-ui/core";

import { Icon } from "../base";
import { COLORS } from "../../theme/colors";
import BuildingImg from "../../assets/images/icons/nav/building-selected.svg";
import { ReactComponent as ArrowPointSVG } from "../../assets/images/icons/arrow-point.svg";

const useStyles = makeStyles((theme) => ({
  first: {
    "& .MuiLinearProgress-barColorPrimary": {
      backgroundColor: COLORS.lightCarminePink,
    },
  },
  second: {
    "& .MuiLinearProgress-barColorPrimary": {
      backgroundColor: COLORS.orange,
    },
  },
  third: {
    "& .MuiLinearProgress-barColorPrimary": {
      backgroundColor: COLORS.maize,
    },
  },
  fourth: {
    "& .MuiLinearProgress-barColorPrimary": {
      backgroundColor: COLORS.dollarBill,
    },
  },
  fifth: {
    "& .MuiLinearProgress-barColorPrimary": {
      backgroundColor: COLORS.green,
    },
  },
  box: {
    backgroundColor: COLORS.darks[0][6],
    borderRadius: "4px 4px 0 0",
    padding: `${theme.spacing(3)}px ${theme.spacing(3.75)}px`,
  },
  title: {
    fontSize: 18,
    fontWeight: 700,
  },
  smallTitle: {
    fontWeight: 400,
  },
  progressBox: {
    minHeight: 105,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  progresses: {
    display: "flex",
    position: "relative",
    maxWidth: 976,
    width: "100%",
  },
  progress: {
    flex: 1,
    borderRadius: 8,
    height: 16,
    "&:not(:last-child)": {
      marginRight: 6,
    },
  },
  smallProgress: {
    borderRadius: 4,
    height: 8,
    "&:not(:last-child)": {
      marginRight: 1,
    },
  },
  svg: {
    position: "absolute",
    top: -36,
  },
  svgBuilding: {
    "& path": {
      fill: COLORS.blue,
    },
    "& circle": {
      fill: COLORS.blue,
    },
  },
  svgPortfolio: {
    "& path": {
      fill: COLORS.spanishGray,
    },
    "& circle": {
      fill: COLORS.spanishGray,
    },
  },
  svgIndustry: {
    "& path": {
      fill: COLORS.black,
    },
    "& circle": {
      fill: COLORS.black,
    },
  },
  outside: {
    zIndex: 1,
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    left: "calc(85% - 27px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 54,
    height: 54,
    backgroundColor: COLORS.white,
    borderRadius: 50,
  },
  outsideSmall: {
    width: 36,
    height: 36,
  },
  inside: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 40,
    height: 40,
    borderRadius: 50,
    backgroundColor: COLORS.blue,
  },
  smallInside: {
    width: 24,
    height: 24,
    backgroundColor: COLORS.purple,
    border: `1px solid ${COLORS.darks[0][25]}`,
  },
  insideText: {
    position: "absolute",
    top: 50,
    fontSize: 36,
    fontWeight: 700,
    whiteSpace: "nowrap",
  },
  smallInsideText: {
    fontSize: 24,
    top: 30,
  },
}));

export const Progresses = ({
  steps,
  size,
  boxStyle,
  title,
  titleStyle,
  points,
  insideStyle,
  insideIcon,
  insideIconSrc,
  outsideStyle,
  insideText,
  insideTextStyle,
  progressStyle,
  mainPointLeft,
  progressBoxStyle,
}) => {
  const classes = useStyles();

  const pointColorClass = {
    building: classes.svgBuilding,
    portfolio: classes.svgPortfolio,
    industry: classes.svgIndustry,
  };

  const getInsideText = (text, left) => {
    let color = COLORS.green;
    if (left < 20) {
      color = COLORS.lightCarminePink;
    } else if (left < 40) {
      color = COLORS.orange;
    } else if (left < 60) {
      color = COLORS.maize;
    } else if (left < 80) {
      color = COLORS.dollarBill;
    }

    return (
      <Typography
        className={`
        ${classes.insideText}
        ${size === "small" ? classes.smallInsideText : null}
      `}
        style={{
          color: color,
          ...insideTextStyle,
        }}
      >
        {text}
      </Typography>
    );
  };

  const getArrow = (i, point) => {
    let styles = {};
    let colorClasses;

    if (size === "small") {
      styles = {
        top: -28,
        width: 18,
        left: `calc(${point.left}% - 9px)`,
      };
    } else {
      styles = {
        left: `calc(${point.left}% - 14px)`,
      };
    }
    colorClasses = pointColorClass[point.type];

    return <ArrowPointSVG key={i} className={`${classes.svg} ${colorClasses}`} style={styles} />;
  };

  return (
    <Box className={classes.box} style={boxStyle}>
      {title && (
        <Typography
          className={`${classes.title} ${size === "small" ? classes.smallTitle : null}`}
          style={titleStyle}
        >
          {title}
        </Typography>
      )}
      <Box className={classes.progressBox} style={progressBoxStyle}>
        <Box className={classes.progresses}>
          {points.map((point, i) => getArrow(i, point))}
          <Box
            className={`${classes.outside} ${size === "small" ? classes.outsideSmall : null}`}
            style={{
              left: `calc(${mainPointLeft}% - ${size === "small" ? "18px" : "27px"})`,
              ...outsideStyle,
            }}
          >
            <Box
              className={`
                ${classes.inside}
                ${size === "small" ? classes.smallInside : null}
              `}
              style={insideStyle}
            >
              {insideIcon || <Icon src={insideIconSrc} />}
            </Box>
            {getInsideText(insideText, mainPointLeft)}
          </Box>
          {[classes.first, classes.second, classes.third, classes.fourth, classes.fifth].map(
            (stepClass, i) =>
              steps.includes(i) ? (
                <LinearProgress
                  key={i}
                  variant="determinate"
                  value={100}
                  className={`
                ${stepClass}
                ${classes.progress}
                ${size === "small" ? classes.smallProgress : null}
              `}
                  style={progressStyle}
                />
              ) : null
          )}
        </Box>
      </Box>
    </Box>
  );
};

Progresses.defaultProps = {
  steps: [0, 1, 2, 3, 4],
  points: [],
  size: "large",
  insideBackground: COLORS.blue,
  insideIconSrc: BuildingImg,
};
